import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { t } from '@/plugins/i18n';
import { prepareAvailableFloorsLevels } from '@/service/helpers';
import { useLocationsStore, useNewFloorStore, useFloorsStore } from '@/stores';
import TooltippedText
  from "@eencloud/eewc-components/src/components/tooltip/TooltippedText/TooltippedText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectFloor',
  props: {
    stepIndex: null
  },
  setup(__props: any) {

const props = __props as {
  stepIndex: number
};

const floors = useFloorsStore();
const locations = useLocationsStore();
const newFloorStore = useNewFloorStore();



const currentFloor = computed(() => {
  return {
    text: newFloorStore?.selectedFloor,
    value: newFloorStore?.selectedFloor
  }
})

const availableFloors = computed(()=>{
  const usedFloors = newFloorStore.locationFloors || [];
  return prepareAvailableFloorsLevels(usedFloors);
})

const selectFloor = function(floor: {text: string, value: number}) {
  newFloorStore.$patch({
    selectedFloor: floor.value,
    newFloorName:`${t('Floor')} ${floor.value}`,
    defaultFloorName: `${t('Floor')} ${floor.value}`
  })
  newFloorStore.setIsCompletedStep(props.stepIndex, true)
}


return { __sfc: true,floors, locations, newFloorStore, props, currentFloor, availableFloors, selectFloor, t, TooltippedText }
}

})